import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import KurumsalPage from "@/pages/KurumsalPage";
import FaaliyetAlanlariPage from "@/pages/FaaliyetAlanlariPage";
import ProjeYaklasimimizPage from "@/pages/ProjeYaklasimimizPage";
import GayrimenkulPage from "@/pages/GayrimenkulPage";
import IletisimPage from "@/pages/IletisimPage";
import KvkkPage from "@/pages/KvkkPage";
import CerezPage from "@/pages/CerezPage";
import GizlilikPage from "@/pages/GizlilikPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/kurumsal" element={<KurumsalPage />} />
            <Route path="/faaliyet-alanlari" element={<FaaliyetAlanlariPage />} />
            <Route path="/proje-yaklasimimiz" element={<ProjeYaklasimimizPage />} />
            <Route path="/gayrimenkul-gelistirme" element={<GayrimenkulPage />} />
            <Route path="/iletisim" element={<IletisimPage />} />
            <Route path="/kvkk-aydinlatma-metni" element={<KvkkPage />} />
            <Route path="/cerez-politikasi" element={<CerezPage />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A192F",
            color: "#ffffff",
            border: "1px solid rgba(197,160,89,0.4)",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
